import { get } from "@/utils/ajax";

export interface Info {
  activity_id: number; // 活动id，定值14
  cate_id: number; // 分类id
  cate_name: string; // 分类名称，精准匹配
  page: number; // 当前页，默认1
  page_size: number; // 当前展示条数，默认20
}

export async function getCategory(data: any): Promise<any> {
  return get("/admin/basic/jd/image/category", data);
}

export async function getImageList(data: any): Promise<any> {
  return get("/admin/basic/jd/image/list", data);
}
